module.exports = __webpack_public_path__ + "img/cuki.52e4ceee.jpg";